import React from "react";

export default function PrivacyPolicy() {
  return (
    <>
      <section className="text-center py-5 bg-light px-4">
        <h2 className="text-uppercase fw-semibold text-primary small">
          Legal & Compliance
        </h2>
        <h1 className="mt-3 display-4 fw-bold text-dark">Privacy Policy</h1>
        <p className="mt-3 text-secondary fs-5 w-75 mx-auto">
          This Privacy Policy explains how we collect, use, disclose, and
          safeguard your information when you use our mobile application.
        </p>
      </section>

      <div className="container py-5 px-md-5 px-3">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <section className="mb-5">
              <p>
                <strong>Effective Date:</strong> 02-04-2025
              </p>
              <p>
                <strong>App Name:</strong> Fieldsathi
              </p>
              <p>
                We are committed to protecting your privacy and ensuring you
                have a positive experience using our app.
              </p>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold text-dark">1. Information We Collect</h3>
              <p>
                <strong>a. Personal Data:</strong>
              </p>
              <ul>
                <li>Location data (coarse and fine)</li>
                <li>Camera access for capturing photos/videos</li>
                <li>Access to media files from your storage</li>
              </ul>
              <p>
                <strong>b. Non-Personal Data:</strong>
              </p>
              <ul>
                <li>Device info (model, OS version, etc.)</li>
                <li>Crash logs and usage stats</li>
                <li>Network connection status</li>
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                2. How We Use Your Information
              </h4>
              <ul>
                <li>Enable photo capture, location tracking, file uploads</li>
                <li>Improve app performance and features</li>
                <li>Troubleshoot issues and ensure security</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                3. Permissions Explanation
              </h4>
              <ul>
                <li>
                  <strong>CAMERA:</strong> Take photos/scan content in app
                </li>
                <li>
                  <strong>LOCATION:</strong> Needed for GPS/map features
                </li>
                <li>
                  <strong>STORAGE:</strong> Upload/save/access media
                </li>
                <li>
                  <strong>MEDIA:</strong> View/edit media in app
                </li>
                <li>
                  <strong>INTERNET:</strong> Server communication
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                4. Data Storage and Retention
              </h4>
              <p>
                Data is securely stored locally or on our servers. Retention is
                only as long as needed for outlined purposes.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                5. Sharing of Information
              </h4>
              <p>We don’t sell/trade personal data. We share data only:</p>
              <ul>
                <li>With your consent</li>
                <li>To comply with legal obligations</li>
                <li>With trusted third parties under data agreements</li>
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">6. Third-Party Services</h4>
              <p>
                Our app may include third-party SDKs. Their data use is governed
                by their privacy policies.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">7. Data Security</h4>
              <p>
                We use security measures to protect data, but no system is 100%
                secure.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">8. Children’s Privacy</h4>
              <p>
                We don’t knowingly collect data from children under 13. If
                found, we delete such data promptly.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">9. Your Rights</h4>
              <ul>
                <li>Access/update/delete your data</li>
                <li>Withdraw consent at any time</li>
                <li>Request info on how your data is used</li>
              </ul>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">
                10. Changes to This Policy
              </h4>
              <p>
                We may update this Privacy Policy. Changes will be posted here
                with a revised effective date.
              </p>
            </section>

            <section className="mb-5">
              <h4 className="fw-semibold text-dark">11. Contact Us</h4>
              <p>
                If you have questions, contact us at:{" "}
                <strong>fieldsathi@gmail.com</strong>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
